import React, { useState, useContext } from "react";
import { formatDate } from "helpers/date";
import { useTranslation } from "react-i18next";
import AttendantCard from "./attendant-card";
import styles from "./next-game.module.css";
import instance from "services/api";
import ToggleActions from "components/functional/toggle-actions";
import { MembershipContext } from "hoc/membership-data";
import { useNavigate } from "react-router";
import { permissionsService } from "services/permissions.service";
import { CalendarCheck, Users, UserX, Settings } from "lucide-react";

const NextGame = ({ game }) => {
  const [participants, setParticipants] = useState(game.participants);
  const navigate = useNavigate();

  const formattedDate = formatDate(game.date, "dddd DD/MM - HH:mm");
  const { t } = useTranslation();
  const membershipData = useContext(MembershipContext);
  const { teams } = membershipData;
  const { team_id, is_player, player_id, is_archived } = teams[0];

  const fetchTeamParticipants = async () => {
    try {
      const response = await instance.get(
        `/games/${game.id}/teams/${team_id}/participants`
      );
      setParticipants(response.data);
    } catch (error) {}
  };

  const actionsLink = {
    manage_team: `/teams/${team_id}/management`,
    manage_own_attendance: `/teams/${team_id}/delete`,
    manage_team_attendance: `/teams/${team_id}/attendance`,
  };

  const myTeam = team_id === game.team1.team_id ? game.team1 : game.team2;
  const otherTeam = team_id === game.team1.team_id ? game.team2 : game.team1;

  const updateAttendance = async (is_participating) => {
    try {
      await instance.put(`/games/${game.id}/players/${player_id}`, {
        status: is_participating ? "CONFIRMED" : "CANCELLED",
        team_id,
      });
      await fetchTeamParticipants();
    } catch (error) {}
  };

  const gameActions = [
    {
      permission: "manage_team",
      label: t("teams.card.actions.manage_team"),
      icon: <Users size={16} className="icon icon-secondary" />,
      command: () => navigate(actionsLink.manage_team),
    },
    {
      permission: "manage_own_attendance",
      label: t("teams.card.actions.cancel_attendance"),
      icon: <UserX size={16} className="icon icon-secondary" />,
      command: () => updateAttendance(false),
      hidden: !is_player,
    },
    // {
    //   permission: "manage_team_attendance",
    //   label: t("teams.card.actions.manage_team_attendance"),
    //   icon: <UsersRound size={16} className="icon icon-secondary" />,
    //   command: () => navigate(actionsLink.manage_team_attendance),
    // },
  ].filter(
    (action) =>
      !action.hidden &&
      permissionsService.hasPermission(action.permission, team_id)
  );

  return (
    <div className={styles["next-game"]}>
      <div className={styles["game-header"]}>
        <div className={styles["game-info"]}>
          <h2 className="title-3">{t("dashboard.next-game.title")}</h2>
          <p className="subtitle-2">{game.location}</p>
        </div>
        <div className={styles["game-time"]}>
          <CalendarCheck size={16} className="icon icon-secondary" />
          <p className="title-4 titlecase">{formattedDate}</p>
        </div>
      </div>
      <div className={styles["game-body"]}>
        <div className={styles["game-team"]}>
          <img
            className={styles["team-logo"]}
            height="50"
            src={myTeam.logo ? `logos/${myTeam.logo}` : `logos/first-team.png`}
            alt={`${myTeam.name} logo`}
          />
          <p className="title-3">{myTeam.name}</p>
        </div>
        <p className={styles.versus}>VS</p>
        <div className={styles["game-team"]}>
          <img
            className={styles["team-logo"]}
            height="50"
            src={
              otherTeam.logo
                ? `logos/${otherTeam.logo}`
                : `logos/second-team.png`
            }
            alt={`${otherTeam.name} logo`}
          />
          <p className="title-3">{otherTeam.name}</p>
        </div>
      </div>
      <AttendantCard
        participants={participants}
        currentPlayerId={game.current_player_id}
        game={game}
      />
      <div className={styles.actions}>
        <ToggleActions
          actions={gameActions}
          btn={{
            class: "btn--secondary",
            icon: <Settings size={20} className="icon icon-secondary" />,
          }}
        />
        {is_player && !is_archived && (
          <button
            type="button"
            disabled={game.status === "CANCELLED"}
            className="btn btn--primary"
            onClick={() => updateAttendance(true)}
          >
            {t("dashboard.next-game.actions.pay-my-place")}
          </button>
        )}
      </div>
    </div>
  );
};

export default NextGame;
